import React from 'react';

// 演習画面（形状変更／視点変更）の共通レイアウト。
// 左＝シミュレーション（children）、右＝説明シート（aside）の2カラムで、
// どちらの演習でも同じ骨格・同じ見出しの出方になるようにここで統一する。
// 見出し（eyebrow／問N／操作の説明）もここで描き、各演習コンポーネントは
// 「状態の編成＋シミュレーションの中身」だけに集中させる。
// aside を省くとシミュレーションが全幅になる（X-1＝PartSelect は説明シートを出さない）。
function ExerciseWorkspace({ eyebrow, number, instruction, aside = null, children }) {
  return (
    <div className="exercise-workspace">
      <section className="exercise-stage">
        <header className="exercise-stage__head">
          {eyebrow && <p className="exercise-stage__eyebrow">{eyebrow}</p>}
          {/* 問番号はタブ表記（問N-M）と揃える。デモ利用時（number未指定）は出さない */}
          {typeof number === 'number' && <h2 className="exercise-stage__title">問{number}</h2>}
          {instruction && <div className="exercise-stage__instruction">{instruction}</div>}
        </header>
        <div className="exercise-stage__body">{children}</div>
      </section>
      {aside && <aside className="exercise-aside">{aside}</aside>}
    </div>
  );
}

export default ExerciseWorkspace;
